"use client";

import React from "react";
import type RootStore from "../mobx/root";

export const RootStoreContext = React.createContext<RootStore | null>(null);
